import { render, staticRenderFns } from "./modalNiveles.vue?vue&type=template&id=05091a35&scoped=true&"
import script from "./modalNiveles.vue?vue&type=script&lang=js&"
export * from "./modalNiveles.vue?vue&type=script&lang=js&"
import style0 from "./modalNiveles.vue?vue&type=style&index=0&id=05091a35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05091a35",
  null
  
)

export default component.exports